var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 719,
    height: 348,
    viewBox: "0 0 719 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_13619)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L52.95 -2.31452e-06L52.95 52.95L2.31452e-06 52.95L0 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 52.95L52.95 53.5016L53.5016 53.5016L53.5016 52.95L52.95 52.95ZM52.95 -2.31452e-06L52.3984 -2.29041e-06L52.3984 52.95L52.95 52.95L53.5016 52.95L53.5016 -2.33863e-06L52.95 -2.31452e-06ZM52.95 52.95L52.95 52.3984L2.29041e-06 52.3984L2.31452e-06 52.95L2.33863e-06 53.5016L52.95 53.5016L52.95 52.95Z",
    fill: "white",
    mask: "url(#path-3-inside-1_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 0L105.9 -2.31452e-06L105.9 52.95L52.95 52.95L52.95 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 52.95L105.9 53.5016L106.452 53.5016L106.452 52.95L105.9 52.95ZM105.9 -2.31452e-06L105.348 -2.29041e-06L105.348 52.95L105.9 52.95L106.452 52.95L106.452 -2.33863e-06L105.9 -2.31452e-06ZM105.9 52.95L105.9 52.3984L52.95 52.3984L52.95 52.95L52.95 53.5016L105.9 53.5016L105.9 52.95Z",
    fill: "white",
    mask: "url(#path-5-inside-2_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 0L158.85 -2.31452e-06L158.85 52.95L105.9 52.95L105.9 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 52.95L158.85 53.5016L159.402 53.5016L159.402 52.95L158.85 52.95ZM158.85 -2.31452e-06L158.298 -2.29041e-06L158.298 52.95L158.85 52.95L159.402 52.95L159.402 -2.33863e-06L158.85 -2.31452e-06ZM158.85 52.95L158.85 52.3984L105.9 52.3984L105.9 52.95L105.9 53.5016L158.85 53.5016L158.85 52.95Z",
    fill: "white",
    mask: "url(#path-7-inside-3_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-4_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 0L211.8 -2.31452e-06L211.8 52.95L158.85 52.95L158.85 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 52.95L211.8 53.5016L212.352 53.5016L212.352 52.95L211.8 52.95ZM211.8 -2.31452e-06L211.248 -2.29041e-06L211.248 52.95L211.8 52.95L212.352 52.95L212.352 -2.33863e-06L211.8 -2.31452e-06ZM211.8 52.95L211.8 52.3984L158.85 52.3984L158.85 52.95L158.85 53.5016L211.8 53.5016L211.8 52.95Z",
    fill: "white",
    mask: "url(#path-9-inside-4_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-5_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 0L264.75 -2.31452e-06L264.75 52.95L211.8 52.95L211.8 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 52.95L264.75 53.5016L265.302 53.5016L265.302 52.95L264.75 52.95ZM264.75 -2.31452e-06L264.198 -2.29041e-06L264.198 52.95L264.75 52.95L265.302 52.95L265.302 -2.33863e-06L264.75 -2.31452e-06ZM264.75 52.95L264.75 52.3984L211.8 52.3984L211.8 52.95L211.8 53.5016L264.75 53.5016L264.75 52.95Z",
    fill: "white",
    mask: "url(#path-11-inside-5_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-6_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 0L317.7 -2.31452e-06L317.7 52.95L264.75 52.95L264.75 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 52.95L317.7 53.5016L318.252 53.5016L318.252 52.95L317.7 52.95ZM317.7 -2.31452e-06L317.148 -2.29041e-06L317.148 52.95L317.7 52.95L318.252 52.95L318.252 -2.33863e-06L317.7 -2.31452e-06ZM317.7 52.95L317.7 52.3984L264.75 52.3984L264.75 52.95L264.75 53.5016L317.7 53.5016L317.7 52.95Z",
    fill: "white",
    mask: "url(#path-13-inside-6_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-7_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 0L370.65 -2.31452e-06L370.65 52.95L317.7 52.95L317.7 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 52.95L370.65 53.5016L371.202 53.5016L371.202 52.95L370.65 52.95ZM370.65 -2.31452e-06L370.098 -2.29041e-06L370.098 52.95L370.65 52.95L371.202 52.95L371.202 -2.33863e-06L370.65 -2.31452e-06ZM370.65 52.95L370.65 52.3984L317.7 52.3984L317.7 52.95L317.7 53.5016L370.65 53.5016L370.65 52.95Z",
    fill: "white",
    mask: "url(#path-15-inside-7_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-8_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 0L423.6 -2.31452e-06L423.6 52.95L370.65 52.95L370.65 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 52.95L423.6 53.5016L424.152 53.5016L424.152 52.95L423.6 52.95ZM423.6 -2.31452e-06L423.048 -2.29041e-06L423.048 52.95L423.6 52.95L424.152 52.95L424.152 -2.33863e-06L423.6 -2.31452e-06ZM423.6 52.95L423.6 52.3984L370.65 52.3984L370.65 52.95L370.65 53.5016L423.6 53.5016L423.6 52.95Z",
    fill: "white",
    mask: "url(#path-17-inside-8_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-9_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 0L476.55 -2.31452e-06L476.55 52.95L423.6 52.95L423.6 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 52.95L476.55 53.5016L477.102 53.5016L477.102 52.95L476.55 52.95ZM476.55 -2.31452e-06L475.998 -2.29041e-06L475.998 52.95L476.55 52.95L477.102 52.95L477.102 -2.33863e-06L476.55 -2.31452e-06ZM476.55 52.95L476.55 52.3984L423.6 52.3984L423.6 52.95L423.6 53.5016L476.55 53.5016L476.55 52.95Z",
    fill: "white",
    mask: "url(#path-19-inside-9_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-10_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 0L529.5 -2.31452e-06L529.5 52.95L476.55 52.95L476.55 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 52.95L529.5 53.5016L530.052 53.5016L530.052 52.95L529.5 52.95ZM529.5 -2.31452e-06L528.948 -2.29041e-06L528.948 52.95L529.5 52.95L530.052 52.95L530.052 -2.33863e-06L529.5 -2.31452e-06ZM529.5 52.95L529.5 52.3984L476.55 52.3984L476.55 52.95L476.55 53.5016L529.5 53.5016L529.5 52.95Z",
    fill: "white",
    mask: "url(#path-21-inside-10_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-11_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 0L582.45 -2.31452e-06L582.45 52.95L529.5 52.95L529.5 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 52.95L582.45 53.5016L583.002 53.5016L583.002 52.95L582.45 52.95ZM582.45 -2.31452e-06L581.898 -2.29041e-06L581.899 52.95L582.45 52.95L583.002 52.95L583.002 -2.33863e-06L582.45 -2.31452e-06ZM582.45 52.95L582.45 52.3984L529.5 52.3984L529.5 52.95L529.5 53.5016L582.45 53.5016L582.45 52.95Z",
    fill: "white",
    mask: "url(#path-23-inside-11_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-12_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 0L635.4 -2.31452e-06L635.4 52.95L582.45 52.95L582.45 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 52.95L635.4 53.5016L635.952 53.5016L635.952 52.95L635.4 52.95ZM635.4 -2.31452e-06L634.849 -2.29041e-06L634.849 52.95L635.4 52.95L635.952 52.95L635.952 -2.33863e-06L635.4 -2.31452e-06ZM635.4 52.95L635.4 52.3984L582.45 52.3984L582.45 52.95L582.45 53.5016L635.4 53.5016L635.4 52.95Z",
    fill: "white",
    mask: "url(#path-25-inside-12_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-13_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 0L688.35 -2.31452e-06L688.35 52.95L635.4 52.95L635.4 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 52.95L688.35 53.5016L688.902 53.5016L688.902 52.95L688.35 52.95ZM688.35 -2.31452e-06L687.799 -2.29041e-06L687.799 52.95L688.35 52.95L688.902 52.95L688.902 -2.33863e-06L688.35 -2.31452e-06ZM688.35 52.95L688.35 52.3984L635.4 52.3984L635.4 52.95L635.4 53.5016L688.35 53.5016L688.35 52.95Z",
    fill: "white",
    mask: "url(#path-27-inside-13_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-14_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 0L741.3 -2.31452e-06L741.3 52.95L688.35 52.95L688.35 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 52.95L741.3 53.5016L741.852 53.5016L741.852 52.95L741.3 52.95ZM741.3 -2.31452e-06L740.749 -2.29041e-06L740.749 52.95L741.3 52.95L741.852 52.95L741.852 -2.33863e-06L741.3 -2.31452e-06ZM741.3 52.95L741.3 52.3984L688.35 52.3984L688.35 52.95L688.35 53.5016L741.3 53.5016L741.3 52.95Z",
    fill: "white",
    mask: "url(#path-29-inside-14_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-15_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 52.9492L52.95 52.9492L52.95 105.899L2.31452e-06 105.899L0 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 105.899L52.95 106.451L53.5016 106.451L53.5016 105.899L52.95 105.899ZM52.95 52.9492L52.3984 52.9492L52.3984 105.899L52.95 105.899L53.5016 105.899L53.5016 52.9492L52.95 52.9492ZM52.95 105.899L52.95 105.348L2.29041e-06 105.348L2.31452e-06 105.899L2.33863e-06 106.451L52.95 106.451L52.95 105.899Z",
    fill: "white",
    mask: "url(#path-31-inside-15_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-16_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 52.9492L105.9 52.9492L105.9 105.899L52.95 105.899L52.95 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 105.899L105.9 106.451L106.452 106.451L106.452 105.899L105.9 105.899ZM105.9 52.9492L105.348 52.9492L105.348 105.899L105.9 105.899L106.452 105.899L106.452 52.9492L105.9 52.9492ZM105.9 105.899L105.9 105.348L52.95 105.348L52.95 105.899L52.95 106.451L105.9 106.451L105.9 105.899Z",
    fill: "white",
    mask: "url(#path-33-inside-16_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-17_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 52.9492L158.85 52.9492L158.85 105.899L105.9 105.899L105.9 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 105.899L158.85 106.451L159.402 106.451L159.402 105.899L158.85 105.899ZM158.85 52.9492L158.298 52.9492L158.298 105.899L158.85 105.899L159.402 105.899L159.402 52.9492L158.85 52.9492ZM158.85 105.899L158.85 105.348L105.9 105.348L105.9 105.899L105.9 106.451L158.85 106.451L158.85 105.899Z",
    fill: "white",
    mask: "url(#path-35-inside-17_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-18_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 52.9492L211.8 52.9492L211.8 105.899L158.85 105.899L158.85 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 105.899L211.8 106.451L212.352 106.451L212.352 105.899L211.8 105.899ZM211.8 52.9492L211.248 52.9492L211.248 105.899L211.8 105.899L212.352 105.899L212.352 52.9492L211.8 52.9492ZM211.8 105.899L211.8 105.348L158.85 105.348L158.85 105.899L158.85 106.451L211.8 106.451L211.8 105.899Z",
    fill: "white",
    mask: "url(#path-37-inside-18_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-19_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 52.9492L264.75 52.9492L264.75 105.899L211.8 105.899L211.8 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 105.899L264.75 106.451L265.302 106.451L265.302 105.899L264.75 105.899ZM264.75 52.9492L264.198 52.9492L264.198 105.899L264.75 105.899L265.302 105.899L265.302 52.9492L264.75 52.9492ZM264.75 105.899L264.75 105.348L211.8 105.348L211.8 105.899L211.8 106.451L264.75 106.451L264.75 105.899Z",
    fill: "white",
    mask: "url(#path-39-inside-19_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-20_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 52.9492L317.7 52.9492L317.7 105.899L264.75 105.899L264.75 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 52.9492L317.7 52.9492L317.7 105.899L264.75 105.899L264.75 52.9492Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 105.899L317.7 106.451L318.252 106.451L318.252 105.899L317.7 105.899ZM317.7 52.9492L317.148 52.9492L317.148 105.899L317.7 105.899L318.252 105.899L318.252 52.9492L317.7 52.9492ZM317.7 105.899L317.7 105.348L264.75 105.348L264.75 105.899L264.75 106.451L317.7 106.451L317.7 105.899Z",
    fill: "white",
    mask: "url(#path-41-inside-20_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-21_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 52.9492L370.65 52.9492L370.65 105.899L317.7 105.899L317.7 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 105.899L370.65 106.451L371.202 106.451L371.202 105.899L370.65 105.899ZM370.65 52.9492L370.098 52.9492L370.098 105.899L370.65 105.899L371.202 105.899L371.202 52.9492L370.65 52.9492ZM370.65 105.899L370.65 105.348L317.7 105.348L317.7 105.899L317.7 106.451L370.65 106.451L370.65 105.899Z",
    fill: "white",
    mask: "url(#path-43-inside-21_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-22_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 52.9492L423.6 52.9492L423.6 105.899L370.65 105.899L370.65 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 105.899L423.6 106.451L424.152 106.451L424.152 105.899L423.6 105.899ZM423.6 52.9492L423.048 52.9492L423.048 105.899L423.6 105.899L424.152 105.899L424.152 52.9492L423.6 52.9492ZM423.6 105.899L423.6 105.348L370.65 105.348L370.65 105.899L370.65 106.451L423.6 106.451L423.6 105.899Z",
    fill: "white",
    mask: "url(#path-45-inside-22_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-23_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 52.9492L476.55 52.9492L476.55 105.899L423.6 105.899L423.6 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 105.899L476.55 106.451L477.102 106.451L477.102 105.899L476.55 105.899ZM476.55 52.9492L475.998 52.9492L475.998 105.899L476.55 105.899L477.102 105.899L477.102 52.9492L476.55 52.9492ZM476.55 105.899L476.55 105.348L423.6 105.348L423.6 105.899L423.6 106.451L476.55 106.451L476.55 105.899Z",
    fill: "white",
    mask: "url(#path-47-inside-23_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-24_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 52.9492L529.5 52.9492L529.5 105.899L476.55 105.899L476.55 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 105.899L529.5 106.451L530.052 106.451L530.052 105.899L529.5 105.899ZM529.5 52.9492L528.948 52.9492L528.948 105.899L529.5 105.899L530.052 105.899L530.052 52.9492L529.5 52.9492ZM529.5 105.899L529.5 105.348L476.55 105.348L476.55 105.899L476.55 106.451L529.5 106.451L529.5 105.899Z",
    fill: "white",
    mask: "url(#path-49-inside-24_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-25_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 52.9492L582.45 52.9492L582.45 105.899L529.5 105.899L529.5 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 105.899L582.45 106.451L583.002 106.451L583.002 105.899L582.45 105.899ZM582.45 52.9492L581.899 52.9492L581.899 105.899L582.45 105.899L583.002 105.899L583.002 52.9492L582.45 52.9492ZM582.45 105.899L582.45 105.348L529.5 105.348L529.5 105.899L529.5 106.451L582.45 106.451L582.45 105.899Z",
    fill: "white",
    mask: "url(#path-51-inside-25_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-26_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 52.9492L635.4 52.9492L635.4 105.899L582.45 105.899L582.45 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 105.899L635.4 106.451L635.952 106.451L635.952 105.899L635.4 105.899ZM635.4 52.9492L634.849 52.9492L634.849 105.899L635.4 105.899L635.952 105.899L635.952 52.9492L635.4 52.9492ZM635.4 105.899L635.4 105.348L582.45 105.348L582.45 105.899L582.45 106.451L635.4 106.451L635.4 105.899Z",
    fill: "white",
    mask: "url(#path-53-inside-26_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-27_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 52.9492L688.35 52.9492L688.35 105.899L635.4 105.899L635.4 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 105.899L688.35 106.451L688.902 106.451L688.902 105.899L688.35 105.899ZM688.35 52.9492L687.799 52.9492L687.799 105.899L688.35 105.899L688.902 105.899L688.902 52.9492L688.35 52.9492ZM688.35 105.899L688.35 105.348L635.4 105.348L635.4 105.899L635.4 106.451L688.35 106.451L688.35 105.899Z",
    fill: "white",
    mask: "url(#path-55-inside-27_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-28_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 52.9492L741.3 52.9492L741.3 105.899L688.35 105.899L688.35 52.9492Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 105.899L741.3 106.451L741.852 106.451L741.852 105.899L741.3 105.899ZM741.3 52.9492L740.749 52.9492L740.749 105.899L741.3 105.899L741.852 105.899L741.852 52.9492L741.3 52.9492ZM741.3 105.899L741.3 105.348L688.35 105.348L688.35 105.899L688.35 106.451L741.3 106.451L741.3 105.899Z",
    fill: "white",
    mask: "url(#path-57-inside-28_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-29_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 105.9L52.95 105.9L52.95 158.85L2.31452e-06 158.85L0 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 158.85L52.95 159.402L53.5016 159.402L53.5016 158.85L52.95 158.85ZM52.95 105.9L52.3984 105.9L52.3984 158.85L52.95 158.85L53.5016 158.85L53.5016 105.9L52.95 105.9ZM52.95 158.85L52.95 158.299L2.29041e-06 158.299L2.31452e-06 158.85L2.33863e-06 159.402L52.95 159.402L52.95 158.85Z",
    fill: "white",
    mask: "url(#path-59-inside-29_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-30_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 105.9L105.9 105.9L105.9 158.85L52.95 158.85L52.95 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 158.85L105.9 159.402L106.452 159.402L106.452 158.85L105.9 158.85ZM105.9 105.9L105.348 105.9L105.348 158.85L105.9 158.85L106.452 158.85L106.452 105.9L105.9 105.9ZM105.9 158.85L105.9 158.299L52.95 158.299L52.95 158.85L52.95 159.402L105.9 159.402L105.9 158.85Z",
    fill: "white",
    mask: "url(#path-61-inside-30_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-31_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 105.9L158.85 105.9L158.85 158.85L105.9 158.85L105.9 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 158.85L158.85 159.402L159.402 159.402L159.402 158.85L158.85 158.85ZM158.85 105.9L158.298 105.9L158.298 158.85L158.85 158.85L159.402 158.85L159.402 105.9L158.85 105.9ZM158.85 158.85L158.85 158.299L105.9 158.299L105.9 158.85L105.9 159.402L158.85 159.402L158.85 158.85Z",
    fill: "white",
    mask: "url(#path-63-inside-31_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-65-inside-32_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 105.9L211.8 105.9L211.8 158.85L158.85 158.85L158.85 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 158.85L211.8 159.402L212.352 159.402L212.352 158.85L211.8 158.85ZM211.8 105.9L211.248 105.9L211.248 158.85L211.8 158.85L212.352 158.85L212.352 105.9L211.8 105.9ZM211.8 158.85L211.8 158.299L158.85 158.299L158.85 158.85L158.85 159.402L211.8 159.402L211.8 158.85Z",
    fill: "white",
    mask: "url(#path-65-inside-32_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-67-inside-33_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 105.9L264.75 105.9L264.75 158.85L211.8 158.85L211.8 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 158.85L264.75 159.402L265.302 159.402L265.302 158.85L264.75 158.85ZM264.75 105.9L264.198 105.9L264.198 158.85L264.75 158.85L265.302 158.85L265.302 105.9L264.75 105.9ZM264.75 158.85L264.75 158.299L211.8 158.299L211.8 158.85L211.8 159.402L264.75 159.402L264.75 158.85Z",
    fill: "white",
    mask: "url(#path-67-inside-33_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-69-inside-34_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 105.9L317.7 105.9L317.7 158.85L264.75 158.85L264.75 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 158.85L317.7 159.402L318.252 159.402L318.252 158.85L317.7 158.85ZM317.7 105.9L317.148 105.9L317.148 158.85L317.7 158.85L318.252 158.85L318.252 105.9L317.7 105.9ZM317.7 158.85L317.7 158.299L264.75 158.299L264.75 158.85L264.75 159.402L317.7 159.402L317.7 158.85Z",
    fill: "white",
    mask: "url(#path-69-inside-34_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-35_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 105.9L370.65 105.9L370.65 158.85L317.7 158.85L317.7 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 158.85L370.65 159.402L371.202 159.402L371.202 158.85L370.65 158.85ZM370.65 105.9L370.098 105.9L370.098 158.85L370.65 158.85L371.202 158.85L371.202 105.9L370.65 105.9ZM370.65 158.85L370.65 158.299L317.7 158.299L317.7 158.85L317.7 159.402L370.65 159.402L370.65 158.85Z",
    fill: "white",
    mask: "url(#path-71-inside-35_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-36_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 105.9L423.6 105.9L423.6 158.85L370.65 158.85L370.65 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 105.9L423.6 105.9L423.6 158.85L370.65 158.85L370.65 105.9Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 158.85L423.6 159.402L424.152 159.402L424.152 158.85L423.6 158.85ZM423.6 105.9L423.048 105.9L423.048 158.85L423.6 158.85L424.152 158.85L424.152 105.9L423.6 105.9ZM423.6 158.85L423.6 158.299L370.65 158.299L370.65 158.85L370.65 159.402L423.6 159.402L423.6 158.85Z",
    fill: "white",
    mask: "url(#path-73-inside-36_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-37_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 105.9L476.55 105.9L476.55 158.85L423.6 158.85L423.6 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 158.85L476.55 159.402L477.102 159.402L477.102 158.85L476.55 158.85ZM476.55 105.9L475.998 105.9L475.998 158.85L476.55 158.85L477.102 158.85L477.102 105.9L476.55 105.9ZM476.55 158.85L476.55 158.299L423.6 158.299L423.6 158.85L423.6 159.402L476.55 159.402L476.55 158.85Z",
    fill: "white",
    mask: "url(#path-75-inside-37_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-38_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 105.9L529.5 105.9L529.5 158.85L476.55 158.85L476.55 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 158.85L529.5 159.402L530.052 159.402L530.052 158.85L529.5 158.85ZM529.5 105.9L528.948 105.9L528.948 158.85L529.5 158.85L530.052 158.85L530.052 105.9L529.5 105.9ZM529.5 158.85L529.5 158.299L476.55 158.299L476.55 158.85L476.55 159.402L529.5 159.402L529.5 158.85Z",
    fill: "white",
    mask: "url(#path-77-inside-38_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-39_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 105.9L582.45 105.9L582.45 158.85L529.5 158.85L529.5 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 158.85L582.45 159.402L583.002 159.402L583.002 158.85L582.45 158.85ZM582.45 105.9L581.898 105.9L581.898 158.85L582.45 158.85L583.002 158.85L583.002 105.9L582.45 105.9ZM582.45 158.85L582.45 158.299L529.5 158.299L529.5 158.85L529.5 159.402L582.45 159.402L582.45 158.85Z",
    fill: "white",
    mask: "url(#path-79-inside-39_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-81-inside-40_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 105.9L635.4 105.9L635.4 158.85L582.45 158.85L582.45 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 105.9L635.4 105.9L635.4 158.85L582.45 158.85L582.45 105.9Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 158.85L635.4 159.402L635.952 159.402L635.952 158.85L635.4 158.85ZM635.4 105.9L634.849 105.9L634.849 158.85L635.4 158.85L635.952 158.85L635.952 105.9L635.4 105.9ZM635.4 158.85L635.4 158.299L582.45 158.299L582.45 158.85L582.45 159.402L635.4 159.402L635.4 158.85Z",
    fill: "white",
    mask: "url(#path-81-inside-40_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-41_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 105.9L688.35 105.9L688.35 158.85L635.4 158.85L635.4 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 158.85L688.35 159.402L688.902 159.402L688.902 158.85L688.35 158.85ZM688.35 105.9L687.799 105.9L687.799 158.85L688.35 158.85L688.902 158.85L688.902 105.9L688.35 105.9ZM688.35 158.85L688.35 158.299L635.4 158.299L635.4 158.85L635.4 159.402L688.35 159.402L688.35 158.85Z",
    fill: "white",
    mask: "url(#path-83-inside-41_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-85-inside-42_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 105.9L741.3 105.9L741.3 158.85L688.35 158.85L688.35 105.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 158.85L741.3 159.402L741.852 159.402L741.852 158.85L741.3 158.85ZM741.3 105.9L740.749 105.9L740.749 158.85L741.3 158.85L741.852 158.85L741.852 105.9L741.3 105.9ZM741.3 158.85L741.3 158.299L688.35 158.299L688.35 158.85L688.35 159.402L741.3 159.402L741.3 158.85Z",
    fill: "white",
    mask: "url(#path-85-inside-42_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-87-inside-43_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 158.85L52.95 158.85L52.95 211.8L2.31452e-06 211.8L0 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 211.8L52.95 212.351L53.5016 212.351L53.5016 211.8L52.95 211.8ZM52.95 158.85L52.3984 158.85L52.3984 211.8L52.95 211.8L53.5016 211.8L53.5016 158.85L52.95 158.85ZM52.95 211.8L52.95 211.248L2.29041e-06 211.248L2.31452e-06 211.8L2.33863e-06 212.351L52.95 212.351L52.95 211.8Z",
    fill: "white",
    mask: "url(#path-87-inside-43_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-44_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 158.85L105.9 158.85L105.9 211.8L52.95 211.8L52.95 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 211.8L105.9 212.351L106.452 212.351L106.452 211.8L105.9 211.8ZM105.9 158.85L105.348 158.85L105.348 211.8L105.9 211.8L106.452 211.8L106.452 158.85L105.9 158.85ZM105.9 211.8L105.9 211.248L52.95 211.248L52.95 211.8L52.95 212.351L105.9 212.351L105.9 211.8Z",
    fill: "white",
    mask: "url(#path-89-inside-44_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-91-inside-45_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 158.85L158.85 158.85L158.85 211.8L105.9 211.8L105.9 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 158.85L158.85 158.85L158.85 211.8L105.9 211.8L105.9 158.85Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 211.8L158.85 212.351L159.402 212.351L159.402 211.8L158.85 211.8ZM158.85 158.85L158.298 158.85L158.298 211.8L158.85 211.8L159.402 211.8L159.402 158.85L158.85 158.85ZM158.85 211.8L158.85 211.248L105.9 211.248L105.9 211.8L105.9 212.351L158.85 212.351L158.85 211.8Z",
    fill: "white",
    mask: "url(#path-91-inside-45_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-93-inside-46_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 158.85L211.8 158.85L211.8 211.8L158.85 211.8L158.85 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 211.8L211.8 212.351L212.352 212.351L212.352 211.8L211.8 211.8ZM211.8 158.85L211.248 158.85L211.248 211.8L211.8 211.8L212.352 211.8L212.352 158.85L211.8 158.85ZM211.8 211.8L211.8 211.248L158.85 211.248L158.85 211.8L158.85 212.351L211.8 212.351L211.8 211.8Z",
    fill: "white",
    mask: "url(#path-93-inside-46_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-47_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 158.85L264.75 158.85L264.75 211.8L211.8 211.8L211.8 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 211.8L264.75 212.351L265.302 212.351L265.302 211.8L264.75 211.8ZM264.75 158.85L264.198 158.85L264.198 211.8L264.75 211.8L265.302 211.8L265.302 158.85L264.75 158.85ZM264.75 211.8L264.75 211.248L211.8 211.248L211.8 211.8L211.8 212.351L264.75 212.351L264.75 211.8Z",
    fill: "white",
    mask: "url(#path-95-inside-47_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-97-inside-48_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 158.85L317.7 158.85L317.7 211.8L264.75 211.8L264.75 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 211.8L317.7 212.351L318.252 212.351L318.252 211.8L317.7 211.8ZM317.7 158.85L317.148 158.85L317.148 211.8L317.7 211.8L318.252 211.8L318.252 158.85L317.7 158.85ZM317.7 211.8L317.7 211.248L264.75 211.248L264.75 211.8L264.75 212.351L317.7 212.351L317.7 211.8Z",
    fill: "white",
    mask: "url(#path-97-inside-48_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-99-inside-49_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 158.85L370.65 158.85L370.65 211.8L317.7 211.8L317.7 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 211.8L370.65 212.351L371.202 212.351L371.202 211.8L370.65 211.8ZM370.65 158.85L370.098 158.85L370.098 211.8L370.65 211.8L371.202 211.8L371.202 158.85L370.65 158.85ZM370.65 211.8L370.65 211.248L317.7 211.248L317.7 211.8L317.7 212.351L370.65 212.351L370.65 211.8Z",
    fill: "white",
    mask: "url(#path-99-inside-49_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-101-inside-50_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 158.85L423.6 158.85L423.6 211.8L370.65 211.8L370.65 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 211.8L423.6 212.351L424.152 212.351L424.152 211.8L423.6 211.8ZM423.6 158.85L423.048 158.85L423.048 211.8L423.6 211.8L424.152 211.8L424.152 158.85L423.6 158.85ZM423.6 211.8L423.6 211.248L370.65 211.248L370.65 211.8L370.65 212.351L423.6 212.351L423.6 211.8Z",
    fill: "white",
    mask: "url(#path-101-inside-50_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-103-inside-51_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 158.85L476.55 158.85L476.55 211.8L423.6 211.8L423.6 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 211.8L476.55 212.351L477.102 212.351L477.102 211.8L476.55 211.8ZM476.55 158.85L475.998 158.85L475.998 211.8L476.55 211.8L477.102 211.8L477.102 158.85L476.55 158.85ZM476.55 211.8L476.55 211.248L423.6 211.248L423.6 211.8L423.6 212.351L476.55 212.351L476.55 211.8Z",
    fill: "white",
    mask: "url(#path-103-inside-51_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-105-inside-52_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 158.85L529.5 158.85L529.5 211.8L476.55 211.8L476.55 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 211.8L529.5 212.351L530.052 212.351L530.052 211.8L529.5 211.8ZM529.5 158.85L528.948 158.85L528.948 211.8L529.5 211.8L530.052 211.8L530.052 158.85L529.5 158.85ZM529.5 211.8L529.5 211.248L476.55 211.248L476.55 211.8L476.55 212.351L529.5 212.351L529.5 211.8Z",
    fill: "white",
    mask: "url(#path-105-inside-52_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-107-inside-53_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 158.85L582.45 158.85L582.45 211.8L529.5 211.8L529.5 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 211.8L582.45 212.351L583.002 212.351L583.002 211.8L582.45 211.8ZM582.45 158.85L581.899 158.85L581.899 211.8L582.45 211.8L583.002 211.8L583.002 158.85L582.45 158.85ZM582.45 211.8L582.45 211.248L529.5 211.248L529.5 211.8L529.5 212.351L582.45 212.351L582.45 211.8Z",
    fill: "white",
    mask: "url(#path-107-inside-53_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-109-inside-54_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 158.85L635.4 158.85L635.4 211.8L582.45 211.8L582.45 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 211.8L635.4 212.351L635.952 212.351L635.952 211.8L635.4 211.8ZM635.4 158.85L634.849 158.85L634.849 211.8L635.4 211.8L635.952 211.8L635.952 158.85L635.4 158.85ZM635.4 211.8L635.4 211.248L582.45 211.248L582.45 211.8L582.45 212.351L635.4 212.351L635.4 211.8Z",
    fill: "white",
    mask: "url(#path-109-inside-54_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-55_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 158.85L688.35 158.85L688.35 211.8L635.4 211.8L635.4 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 211.8L688.35 212.351L688.902 212.351L688.902 211.8L688.35 211.8ZM688.35 158.85L687.799 158.85L687.799 211.8L688.35 211.8L688.902 211.8L688.902 158.85L688.35 158.85ZM688.35 211.8L688.35 211.248L635.4 211.248L635.4 211.8L635.4 212.351L688.35 212.351L688.35 211.8Z",
    fill: "white",
    mask: "url(#path-111-inside-55_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-113-inside-56_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 158.85L741.3 158.85L741.3 211.8L688.35 211.8L688.35 158.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 211.8L741.3 212.351L741.852 212.351L741.852 211.8L741.3 211.8ZM741.3 158.85L740.749 158.85L740.749 211.8L741.3 211.8L741.852 211.8L741.852 158.85L741.3 158.85ZM741.3 211.8L741.3 211.248L688.35 211.248L688.35 211.8L688.35 212.351L741.3 212.351L741.3 211.8Z",
    fill: "white",
    mask: "url(#path-113-inside-56_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-115-inside-57_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 211.801L52.95 211.801L52.95 264.751L2.31452e-06 264.751L0 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 264.751L52.95 265.302L53.5016 265.302L53.5016 264.751L52.95 264.751ZM52.95 211.801L52.3984 211.801L52.3984 264.751L52.95 264.751L53.5016 264.751L53.5016 211.801L52.95 211.801ZM52.95 264.751L52.95 264.199L2.29041e-06 264.199L2.31452e-06 264.751L2.33863e-06 265.302L52.95 265.302L52.95 264.751Z",
    fill: "white",
    mask: "url(#path-115-inside-57_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-117-inside-58_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 211.801L105.9 211.801L105.9 264.751L52.95 264.751L52.95 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 264.751L105.9 265.302L106.452 265.302L106.452 264.751L105.9 264.751ZM105.9 211.801L105.348 211.801L105.348 264.751L105.9 264.751L106.452 264.751L106.452 211.801L105.9 211.801ZM105.9 264.751L105.9 264.199L52.95 264.199L52.95 264.751L52.95 265.302L105.9 265.302L105.9 264.751Z",
    fill: "white",
    mask: "url(#path-117-inside-58_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-119-inside-59_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 211.801L158.85 211.801L158.85 264.751L105.9 264.751L105.9 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 264.751L158.85 265.302L159.402 265.302L159.402 264.751L158.85 264.751ZM158.85 211.801L158.298 211.801L158.298 264.751L158.85 264.751L159.402 264.751L159.402 211.801L158.85 211.801ZM158.85 264.751L158.85 264.199L105.9 264.199L105.9 264.751L105.9 265.302L158.85 265.302L158.85 264.751Z",
    fill: "white",
    mask: "url(#path-119-inside-59_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-121-inside-60_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 211.801L211.8 211.801L211.8 264.751L158.85 264.751L158.85 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 264.751L211.8 265.302L212.352 265.302L212.352 264.751L211.8 264.751ZM211.8 211.801L211.248 211.801L211.248 264.751L211.8 264.751L212.352 264.751L212.352 211.801L211.8 211.801ZM211.8 264.751L211.8 264.199L158.85 264.199L158.85 264.751L158.85 265.302L211.8 265.302L211.8 264.751Z",
    fill: "white",
    mask: "url(#path-121-inside-60_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-123-inside-61_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 211.801L264.75 211.801L264.75 264.751L211.8 264.751L211.8 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 264.751L264.75 265.302L265.302 265.302L265.302 264.751L264.75 264.751ZM264.75 211.801L264.198 211.801L264.198 264.751L264.75 264.751L265.302 264.751L265.302 211.801L264.75 211.801ZM264.75 264.751L264.75 264.199L211.8 264.199L211.8 264.751L211.8 265.302L264.75 265.302L264.75 264.751Z",
    fill: "white",
    mask: "url(#path-123-inside-61_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-125-inside-62_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 211.801L317.7 211.801L317.7 264.751L264.75 264.751L264.75 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 264.751L317.7 265.302L318.252 265.302L318.252 264.751L317.7 264.751ZM317.7 211.801L317.148 211.801L317.148 264.751L317.7 264.751L318.252 264.751L318.252 211.801L317.7 211.801ZM317.7 264.751L317.7 264.199L264.75 264.199L264.75 264.751L264.75 265.302L317.7 265.302L317.7 264.751Z",
    fill: "white",
    mask: "url(#path-125-inside-62_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-127-inside-63_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 211.801L370.65 211.801L370.65 264.751L317.7 264.751L317.7 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 264.751L370.65 265.302L371.202 265.302L371.202 264.751L370.65 264.751ZM370.65 211.801L370.098 211.801L370.098 264.751L370.65 264.751L371.202 264.751L371.202 211.801L370.65 211.801ZM370.65 264.751L370.65 264.199L317.7 264.199L317.7 264.751L317.7 265.302L370.65 265.302L370.65 264.751Z",
    fill: "white",
    mask: "url(#path-127-inside-63_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-129-inside-64_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 211.801L423.6 211.801L423.6 264.751L370.65 264.751L370.65 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 264.751L423.6 265.302L424.152 265.302L424.152 264.751L423.6 264.751ZM423.6 211.801L423.048 211.801L423.048 264.751L423.6 264.751L424.152 264.751L424.152 211.801L423.6 211.801ZM423.6 264.751L423.6 264.199L370.65 264.199L370.65 264.751L370.65 265.302L423.6 265.302L423.6 264.751Z",
    fill: "white",
    mask: "url(#path-129-inside-64_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-131-inside-65_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 211.801L476.55 211.801L476.55 264.751L423.6 264.751L423.6 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 211.801L476.55 211.801L476.55 264.751L423.6 264.751L423.6 211.801Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 264.751L476.55 265.302L477.102 265.302L477.102 264.751L476.55 264.751ZM476.55 211.801L475.998 211.801L475.998 264.751L476.55 264.751L477.102 264.751L477.102 211.801L476.55 211.801ZM476.55 264.751L476.55 264.199L423.6 264.199L423.6 264.751L423.6 265.302L476.55 265.302L476.55 264.751Z",
    fill: "white",
    mask: "url(#path-131-inside-65_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-133-inside-66_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 211.801L529.5 211.801L529.5 264.751L476.55 264.751L476.55 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 264.751L529.5 265.302L530.052 265.302L530.052 264.751L529.5 264.751ZM529.5 211.801L528.948 211.801L528.948 264.751L529.5 264.751L530.052 264.751L530.052 211.801L529.5 211.801ZM529.5 264.751L529.5 264.199L476.55 264.199L476.55 264.751L476.55 265.302L529.5 265.302L529.5 264.751Z",
    fill: "white",
    mask: "url(#path-133-inside-66_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-135-inside-67_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 211.801L582.45 211.801L582.45 264.751L529.5 264.751L529.5 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 264.751L582.45 265.302L583.002 265.302L583.002 264.751L582.45 264.751ZM582.45 211.801L581.899 211.801L581.899 264.751L582.45 264.751L583.002 264.751L583.002 211.801L582.45 211.801ZM582.45 264.751L582.45 264.199L529.5 264.199L529.5 264.751L529.5 265.302L582.45 265.302L582.45 264.751Z",
    fill: "white",
    mask: "url(#path-135-inside-67_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-137-inside-68_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 211.801L635.4 211.801L635.4 264.751L582.45 264.751L582.45 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 264.751L635.4 265.302L635.952 265.302L635.952 264.751L635.4 264.751ZM635.4 211.801L634.849 211.801L634.849 264.751L635.4 264.751L635.952 264.751L635.952 211.801L635.4 211.801ZM635.4 264.751L635.4 264.199L582.45 264.199L582.45 264.751L582.45 265.302L635.4 265.302L635.4 264.751Z",
    fill: "white",
    mask: "url(#path-137-inside-68_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-139-inside-69_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 211.801L688.35 211.801L688.35 264.751L635.4 264.751L635.4 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 264.751L688.35 265.302L688.902 265.302L688.902 264.751L688.35 264.751ZM688.35 211.801L687.799 211.801L687.799 264.751L688.35 264.751L688.902 264.751L688.902 211.801L688.35 211.801ZM688.35 264.751L688.35 264.199L635.4 264.199L635.4 264.751L635.4 265.302L688.35 265.302L688.35 264.751Z",
    fill: "white",
    mask: "url(#path-139-inside-69_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-141-inside-70_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 211.801L741.3 211.801L741.3 264.751L688.35 264.751L688.35 211.801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 264.751L741.3 265.302L741.852 265.302L741.852 264.751L741.3 264.751ZM741.3 211.801L740.749 211.801L740.749 264.751L741.3 264.751L741.852 264.751L741.852 211.801L741.3 211.801ZM741.3 264.751L741.3 264.199L688.35 264.199L688.35 264.751L688.35 265.302L741.3 265.302L741.3 264.751Z",
    fill: "white",
    mask: "url(#path-141-inside-70_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-143-inside-71_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 264.75L52.95 264.75L52.95 317.7L2.31452e-06 317.7L0 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 317.7L52.95 318.252L53.5016 318.252L53.5016 317.7L52.95 317.7ZM52.95 264.75L52.3984 264.75L52.3984 317.7L52.95 317.7L53.5016 317.7L53.5016 264.75L52.95 264.75ZM52.95 317.7L52.95 317.148L2.29041e-06 317.148L2.31452e-06 317.7L2.33863e-06 318.252L52.95 318.252L52.95 317.7Z",
    fill: "white",
    mask: "url(#path-143-inside-71_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-145-inside-72_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 264.75L105.9 264.75L105.9 317.7L52.95 317.7L52.95 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 317.7L105.9 318.252L106.452 318.252L106.452 317.7L105.9 317.7ZM105.9 264.75L105.348 264.75L105.348 317.7L105.9 317.7L106.452 317.7L106.452 264.75L105.9 264.75ZM105.9 317.7L105.9 317.148L52.95 317.148L52.95 317.7L52.95 318.252L105.9 318.252L105.9 317.7Z",
    fill: "white",
    mask: "url(#path-145-inside-72_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-147-inside-73_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 264.75L158.85 264.75L158.85 317.7L105.9 317.7L105.9 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 317.7L158.85 318.252L159.402 318.252L159.402 317.7L158.85 317.7ZM158.85 264.75L158.298 264.75L158.298 317.7L158.85 317.7L159.402 317.7L159.402 264.75L158.85 264.75ZM158.85 317.7L158.85 317.148L105.9 317.148L105.9 317.7L105.9 318.252L158.85 318.252L158.85 317.7Z",
    fill: "white",
    mask: "url(#path-147-inside-73_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-149-inside-74_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 264.75L211.8 264.75L211.8 317.7L158.85 317.7L158.85 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 317.7L211.8 318.252L212.352 318.252L212.352 317.7L211.8 317.7ZM211.8 264.75L211.248 264.75L211.248 317.7L211.8 317.7L212.352 317.7L212.352 264.75L211.8 264.75ZM211.8 317.7L211.8 317.148L158.85 317.148L158.85 317.7L158.85 318.252L211.8 318.252L211.8 317.7Z",
    fill: "white",
    mask: "url(#path-149-inside-74_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-151-inside-75_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 264.75L264.75 264.75L264.75 317.7L211.8 317.7L211.8 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 317.7L264.75 318.252L265.302 318.252L265.302 317.7L264.75 317.7ZM264.75 264.75L264.198 264.75L264.198 317.7L264.75 317.7L265.302 317.7L265.302 264.75L264.75 264.75ZM264.75 317.7L264.75 317.148L211.8 317.148L211.8 317.7L211.8 318.252L264.75 318.252L264.75 317.7Z",
    fill: "white",
    mask: "url(#path-151-inside-75_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-153-inside-76_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 264.75L317.7 264.75L317.7 317.7L264.75 317.7L264.75 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 264.75L317.7 264.75L317.7 317.7L264.75 317.7L264.75 264.75Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 317.7L317.7 318.252L318.252 318.252L318.252 317.7L317.7 317.7ZM317.7 264.75L317.148 264.75L317.148 317.7L317.7 317.7L318.252 317.7L318.252 264.75L317.7 264.75ZM317.7 317.7L317.7 317.148L264.75 317.148L264.75 317.7L264.75 318.252L317.7 318.252L317.7 317.7Z",
    fill: "white",
    mask: "url(#path-153-inside-76_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-155-inside-77_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 264.75L370.65 264.75L370.65 317.7L317.7 317.7L317.7 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 317.7L370.65 318.252L371.202 318.252L371.202 317.7L370.65 317.7ZM370.65 264.75L370.098 264.75L370.098 317.7L370.65 317.7L371.202 317.7L371.202 264.75L370.65 264.75ZM370.65 317.7L370.65 317.148L317.7 317.148L317.7 317.7L317.7 318.252L370.65 318.252L370.65 317.7Z",
    fill: "white",
    mask: "url(#path-155-inside-77_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-157-inside-78_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 264.75L423.6 264.75L423.6 317.7L370.65 317.7L370.65 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 317.7L423.6 318.252L424.152 318.252L424.152 317.7L423.6 317.7ZM423.6 264.75L423.048 264.75L423.048 317.7L423.6 317.7L424.152 317.7L424.152 264.75L423.6 264.75ZM423.6 317.7L423.6 317.148L370.65 317.148L370.65 317.7L370.65 318.252L423.6 318.252L423.6 317.7Z",
    fill: "white",
    mask: "url(#path-157-inside-78_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-159-inside-79_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 264.75L476.55 264.75L476.55 317.7L423.6 317.7L423.6 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 317.7L476.55 318.252L477.102 318.252L477.102 317.7L476.55 317.7ZM476.55 264.75L475.998 264.75L475.998 317.7L476.55 317.7L477.102 317.7L477.102 264.75L476.55 264.75ZM476.55 317.7L476.55 317.148L423.6 317.148L423.6 317.7L423.6 318.252L476.55 318.252L476.55 317.7Z",
    fill: "white",
    mask: "url(#path-159-inside-79_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-161-inside-80_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 264.75L529.5 264.75L529.5 317.7L476.55 317.7L476.55 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 317.7L529.5 318.252L530.052 318.252L530.052 317.7L529.5 317.7ZM529.5 264.75L528.948 264.75L528.949 317.7L529.5 317.7L530.052 317.7L530.052 264.75L529.5 264.75ZM529.5 317.7L529.5 317.148L476.55 317.148L476.55 317.7L476.55 318.252L529.5 318.252L529.5 317.7Z",
    fill: "white",
    mask: "url(#path-161-inside-80_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-163-inside-81_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 264.75L582.45 264.75L582.45 317.7L529.5 317.7L529.5 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 317.7L582.45 318.252L583.002 318.252L583.002 317.7L582.45 317.7ZM582.45 264.75L581.899 264.75L581.899 317.7L582.45 317.7L583.002 317.7L583.002 264.75L582.45 264.75ZM582.45 317.7L582.45 317.148L529.5 317.148L529.5 317.7L529.5 318.252L582.45 318.252L582.45 317.7Z",
    fill: "white",
    mask: "url(#path-163-inside-81_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-165-inside-82_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 264.75L635.4 264.75L635.4 317.7L582.45 317.7L582.45 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 264.75L635.4 264.75L635.4 317.7L582.45 317.7L582.45 264.75Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 317.7L635.4 318.252L635.952 318.252L635.952 317.7L635.4 317.7ZM635.4 264.75L634.849 264.75L634.849 317.7L635.4 317.7L635.952 317.7L635.952 264.75L635.4 264.75ZM635.4 317.7L635.4 317.148L582.45 317.148L582.45 317.7L582.45 318.252L635.4 318.252L635.4 317.7Z",
    fill: "white",
    mask: "url(#path-165-inside-82_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-167-inside-83_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 264.75L688.35 264.75L688.35 317.7L635.4 317.7L635.4 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 317.7L688.35 318.252L688.902 318.252L688.902 317.7L688.35 317.7ZM688.35 264.75L687.799 264.75L687.799 317.7L688.35 317.7L688.902 317.7L688.902 264.75L688.35 264.75ZM688.35 317.7L688.35 317.148L635.4 317.148L635.4 317.7L635.4 318.252L688.35 318.252L688.35 317.7Z",
    fill: "white",
    mask: "url(#path-167-inside-83_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-169-inside-84_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 264.75L741.3 264.75L741.3 317.7L688.35 317.7L688.35 264.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 317.7L741.3 318.252L741.852 318.252L741.852 317.7L741.3 317.7ZM741.3 264.75L740.749 264.75L740.749 317.7L741.3 317.7L741.852 317.7L741.852 264.75L741.3 264.75ZM741.3 317.7L741.3 317.148L688.35 317.148L688.35 317.7L688.35 318.252L741.3 318.252L741.3 317.7Z",
    fill: "white",
    mask: "url(#path-169-inside-84_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-171-inside-85_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 317.699L52.95 317.699L52.95 370.649L2.31452e-06 370.649L0 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 370.649L52.95 371.201L53.5016 371.201L53.5016 370.649L52.95 370.649ZM52.95 317.699L52.3984 317.699L52.3984 370.649L52.95 370.649L53.5016 370.649L53.5016 317.699L52.95 317.699ZM52.95 370.649L52.95 370.098L2.29041e-06 370.098L2.31452e-06 370.649L2.33863e-06 371.201L52.95 371.201L52.95 370.649Z",
    fill: "white",
    mask: "url(#path-171-inside-85_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-173-inside-86_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.95 317.699L105.9 317.699L105.9 370.649L52.95 370.649L52.95 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 370.649L105.9 371.201L106.452 371.201L106.452 370.649L105.9 370.649ZM105.9 317.699L105.348 317.699L105.348 370.649L105.9 370.649L106.452 370.649L106.452 317.699L105.9 317.699ZM105.9 370.649L105.9 370.098L52.95 370.098L52.95 370.649L52.95 371.201L105.9 371.201L105.9 370.649Z",
    fill: "white",
    mask: "url(#path-173-inside-86_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-175-inside-87_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.9 317.699L158.85 317.699L158.85 370.649L105.9 370.649L105.9 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 370.649L158.85 371.201L159.402 371.201L159.402 370.649L158.85 370.649ZM158.85 317.699L158.298 317.699L158.298 370.649L158.85 370.649L159.402 370.649L159.402 317.699L158.85 317.699ZM158.85 370.649L158.85 370.098L105.9 370.098L105.9 370.649L105.9 371.201L158.85 371.201L158.85 370.649Z",
    fill: "white",
    mask: "url(#path-175-inside-87_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-177-inside-88_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85 317.699L211.8 317.699L211.8 370.649L158.85 370.649L158.85 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 317.699L211.8 317.699L211.8 370.649L158.85 370.649L158.85 317.699Z",
    fill: "#FFE9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 370.649L211.8 371.201L212.352 371.201L212.352 370.649L211.8 370.649ZM211.8 317.699L211.248 317.699L211.248 370.649L211.8 370.649L212.352 370.649L212.352 317.699L211.8 317.699ZM211.8 370.649L211.8 370.098L158.85 370.098L158.85 370.649L158.85 371.201L211.8 371.201L211.8 370.649Z",
    fill: "white",
    mask: "url(#path-177-inside-88_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-179-inside-89_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8 317.699L264.75 317.699L264.75 370.649L211.8 370.649L211.8 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 370.649L264.75 371.201L265.302 371.201L265.302 370.649L264.75 370.649ZM264.75 317.699L264.198 317.699L264.198 370.649L264.75 370.649L265.302 370.649L265.302 317.699L264.75 317.699ZM264.75 370.649L264.75 370.098L211.8 370.098L211.8 370.649L211.8 371.201L264.75 371.201L264.75 370.649Z",
    fill: "white",
    mask: "url(#path-179-inside-89_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-181-inside-90_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.75 317.699L317.7 317.699L317.7 370.649L264.75 370.649L264.75 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.7 370.649L317.7 371.201L318.252 371.201L318.252 370.649L317.7 370.649ZM317.7 317.699L317.148 317.699L317.148 370.649L317.7 370.649L318.252 370.649L318.252 317.699L317.7 317.699ZM317.7 370.649L317.7 370.098L264.75 370.098L264.75 370.649L264.75 371.201L317.7 371.201L317.7 370.649Z",
    fill: "white",
    mask: "url(#path-181-inside-90_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-183-inside-91_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.7 317.699L370.65 317.699L370.65 370.649L317.7 370.649L317.7 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.65 370.649L370.65 371.201L371.202 371.201L371.202 370.649L370.65 370.649ZM370.65 317.699L370.098 317.699L370.098 370.649L370.65 370.649L371.202 370.649L371.202 317.699L370.65 317.699ZM370.65 370.649L370.65 370.098L317.7 370.098L317.7 370.649L317.7 371.201L370.65 371.201L370.65 370.649Z",
    fill: "white",
    mask: "url(#path-183-inside-91_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-185-inside-92_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65 317.699L423.6 317.699L423.6 370.649L370.65 370.649L370.65 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 370.649L423.6 371.201L424.152 371.201L424.152 370.649L423.6 370.649ZM423.6 317.699L423.048 317.699L423.048 370.649L423.6 370.649L424.152 370.649L424.152 317.699L423.6 317.699ZM423.6 370.649L423.6 370.098L370.65 370.098L370.65 370.649L370.65 371.201L423.6 371.201L423.6 370.649Z",
    fill: "white",
    mask: "url(#path-185-inside-92_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-187-inside-93_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.6 317.699L476.55 317.699L476.55 370.649L423.6 370.649L423.6 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.55 370.649L476.55 371.201L477.102 371.201L477.102 370.649L476.55 370.649ZM476.55 317.699L475.998 317.699L475.998 370.649L476.55 370.649L477.102 370.649L477.102 317.699L476.55 317.699ZM476.55 370.649L476.55 370.098L423.6 370.098L423.6 370.649L423.6 371.201L476.55 371.201L476.55 370.649Z",
    fill: "white",
    mask: "url(#path-187-inside-93_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-189-inside-94_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.55 317.699L529.5 317.699L529.5 370.649L476.55 370.649L476.55 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 370.649L529.5 371.201L530.052 371.201L530.052 370.649L529.5 370.649ZM529.5 317.699L528.949 317.699L528.949 370.649L529.5 370.649L530.052 370.649L530.052 317.699L529.5 317.699ZM529.5 370.649L529.5 370.098L476.55 370.098L476.55 370.649L476.55 371.201L529.5 371.201L529.5 370.649Z",
    fill: "white",
    mask: "url(#path-189-inside-94_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-191-inside-95_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 317.699L582.45 317.699L582.45 370.649L529.5 370.649L529.5 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.45 370.649L582.45 371.201L583.002 371.201L583.002 370.649L582.45 370.649ZM582.45 317.699L581.899 317.699L581.899 370.649L582.45 370.649L583.002 370.649L583.002 317.699L582.45 317.699ZM582.45 370.649L582.45 370.098L529.5 370.098L529.5 370.649L529.5 371.201L582.45 371.201L582.45 370.649Z",
    fill: "white",
    mask: "url(#path-191-inside-95_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-193-inside-96_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.45 317.699L635.4 317.699L635.4 370.649L582.45 370.649L582.45 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.4 370.649L635.4 371.201L635.952 371.201L635.952 370.649L635.4 370.649ZM635.4 317.699L634.849 317.699L634.849 370.649L635.4 370.649L635.952 370.649L635.952 317.699L635.4 317.699ZM635.4 370.649L635.4 370.098L582.45 370.098L582.45 370.649L582.45 371.201L635.4 371.201L635.4 370.649Z",
    fill: "white",
    mask: "url(#path-193-inside-96_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-195-inside-97_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.4 317.699L688.35 317.699L688.35 370.649L635.4 370.649L635.4 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.35 370.649L688.35 371.201L688.902 371.201L688.902 370.649L688.35 370.649ZM688.35 317.699L687.799 317.699L687.799 370.649L688.35 370.649L688.902 370.649L688.902 317.699L688.35 317.699ZM688.35 370.649L688.35 370.098L635.4 370.098L635.4 370.649L635.4 371.201L688.35 371.201L688.35 370.649Z",
    fill: "white",
    mask: "url(#path-195-inside-97_1155_13619)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-197-inside-98_1155_13619",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.35 317.699L741.3 317.699L741.3 370.649L688.35 370.649L688.35 317.699Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3 370.649L741.3 371.201L741.852 371.201L741.852 370.649L741.3 370.649ZM741.3 317.699L740.749 317.699L740.749 370.649L741.3 370.649L741.852 370.649L741.852 317.699L741.3 317.699ZM741.3 370.649L741.3 370.098L688.35 370.098L688.35 370.649L688.35 371.201L741.3 371.201L741.3 370.649Z",
    fill: "white",
    mask: "url(#path-197-inside-98_1155_13619)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275781,
    y: 0.275781,
    width: 1058.45,
    height: 793.698,
    stroke: "white",
    strokeWidth: 0.551562
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_13619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1059,
    height: 794.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.44675dbfebd644b60c1d1326d93e56f1.svg";
export { ForwardRef as ReactComponent };